export default __webpack_public_path__ + "static/media/maxime_kenzo.96a021a5.jpg";